/**
 * Utility to parse room/destination name string containing multiple names separated by delimiters (, ; | /)
 * Supports dynamic English translation based on active language.
 */

const translationMap = {
  // Room names (primary)
  "ห้องจ่ายยาผู้ป่วยนอก เบอร์ 30": "Outpatient pharmacy unit no.30",
  "ศูนย์รับเงิน 2": "Cashier center 2",
  "ศูนย์ประสานสิทธิ์ผู้ป่วยนอก": "Outpatient health insurance coverage center",
  "ศูนย์จองห้องพิเศษ": "Private room reservation center",
  "ศูนย์ส่งยาทางไปรษณีย์": "Suandok medication delivery service center",
  "ศูนย์ประสานงานและบริการผู้ป่วย": "Customer service center",
  "แผนกเวชระเบียน": "Medical record",
  "ห้องสวนหัวใจและหลอดเลือด 2": "Cathlab 2",
  "ห้องเอ็มอาร์ไอหัวใจ": "Cardiac MRI",
  "ห้องฉีดยา": "Injection room",
  "ห้อง CT เบอร์ 51": "CT scan Room 51",
  "ห้อง CT เบอร์ 52": "CT scan Room 52",
  "ห้องเจาะเลือด": "Blood collection unit OPD 11",
  "ห้องเจาะเลือด รถเข็น/เปลนอน": "Blood collection unit OPD 13",
  "หน่วยเคมีคลินิก": "Clinical chemistry laboratory",
  "หน่วยจุลทรรศนศาสตร์คลินิก": "clinical microscopy laboratory",
  "ห้องตรวจกระดูกและข้อ เบอร์ 10": "Outpatient clinic No.10, Spine center",
  "ผู้ป่วยสังเกตอาการ": "Observation ward",
  "ห้องตรวจเบอร์ 24": "Outpatient clinic No.24",
  "ทันตกรรม": "Dental clinic No.25",
  "ห้องเบอร์ 33": "Room No.33",
  "ห้องตรวจคลื่นไฟฟ้าหัวใจ เบอร์ 12": "Electrocardiogram unit",
  "ห้องตรวจด้วยคลื่นสะท้อนสนามแม่เหล็กไฟฟ้า": "MRI",
  "ห้องตรวจพิเศษศัลยกรรม 2": "Outpatient clinic No.2",
  "ห้องเอกซ์เรย์ เบอร์ 35": "X-ray room no.35",
  "ห้องเอกซ์เรย์ เบอร์ 37": "X-ray room no.37",
  "ห้องเอกซ์เรย์ เบอร์ 39": "X-ray room no.39",
  "ห้องเอกซ์เรย์ เบอร์ 43": "X-ray room no.43",
  "ห้องเอกซ์เรย์ เบอร์ 44": "X-ray room no.44",
  "ห้องเอกซ์เรย์ เบอร์ 45": "X-ray room no.45",
  "ห้องเอกซ์เรย์ เบอร์ 46": "X-ray room no.46",
  "ห้องเอกซ์เรย์ เบอร์ 47": "X-ray room no.47",
  "ห้องเอกซ์เรย์ เบอร์ 50": "X-ray room no.50",


  // Sriphat Building (อาคารศรีพัฒน์)
  "ห้องจ่ายยาผู้ป่วยนอก เบอร์ 16": "Outpatient pharmacy unit no.16",
  "ศูนย์รับเงิน เบอร์ 3": "Cashier no. 3",
  "หน่วยสร้างเสริมสุขภาพ": "Health Promotion Unit",
  "ห้องรับบริจาคเลือด": "Bloodbank section",
  "งานเวชภัณฑ์ปลอดเชื้อ": "CSSD",
  "ห้องตรวจทางรังสีวิทยา": "Radiology examination unit",
  "ห้องสลายนิ่ว": "Urodynamic",
  "หอผู้ป่วยหนักศัลยกรรม ทรวงอกและหลอดเลือด": "ICU CVT",
  "ห้องผ่าตัด": "Operating room",
  "ห้องตรวจนรีเวช (เบอร์ 3)": "Outpatient clinic No.3",
  "ห้องฝากครรภ์ (เบอร์ 4)": "Outpatient clinic No.4",
  "ห้องวางแผนครอบครัว (เบอร์ 5)": "Outpatient clinic No.5",
  "ห้องตรวจ CMU Pride": "CMU Pride",
  "OPD3-Primary HPV Screening": "OPD3-Primary HPV Screening",
  "Patho - Primary HPV Screening": "Patho - Primary HPV Screening",
  "Patho - Liquid-based cytology(Primary HPV Screen": "Patho - Liquid-based cytology(Primary HPV Screenin",
  "Patho - Liquid-based cytology(Primary HPV Screenin": "Patho - Liquid-based cytology(Primary HPV Screenin",
  "ห้องตรวจโรคจอตาและวุ้นตา": "OPD Retina",
  "OPD พิเศษเด็ก1 (OPD27)": "Outpatient clinic No.27",
  "หน่วยตรวจกุมาร": "Pediatric outpatient department",
  "ห้องตรวจพิเศษเด็ก 3": "Outpatient clinic No.29",
  "คลินิกวัคซีนเด็ก(วัคซีนพื้นฐาน)": "Pediatric vaccine clinic (Basic vaccines)",
  "ห้องจ่ายยาเด็ก": "Cashier",
  "ห้องตรวจ หู คอ จมูก": "Outpatient clinic No.6",
  "ห้องรับบริจากเลือด": "Bloodbank section",

  // Sriphat Building (อาคารศรีพัฒน์) - Floors 7-15
  "ห้องตรวจตา เบอร์ 7": "Outpatient clinic No.7",
  "หอผู้ป่วยหนักโรคหัวใจและหลอดเลือด 1 และ 2": "Cardiac care unit",
  "ห้องตรวจสวนหัวใจและหลอดเลือด": "Cardiac Catheterization Room",
  "คลินิก Telemedicine (หัวใจล้มเหลว)": "Telemedicine",
  "ห้องตรวจ Telemedicine (ACS)": "Telemedicine",
  "พิเศษอายุรกรรม 1 (เบอร์ 21)": "Outpatient clinic No.21",
  "ศูนย์โรคสมอง": "Neuroscience Center",
  "คลินิกระงับปวด": "Pain Clinic",
  "ห้องตรวจประเมินและเตรียมความพร้อมผู้ป่วยก่อนผ่าตัด": "Pre-operative evaluation and preparation room",
  "หอผู้ป่วยวิกฤติโรคหลอดเลือดสมอง": "Stroke Unit",
  "พิเศษอายุรกรรม 3 เบอร์ 26": "Outpatient clinic No.26",
  "หน่วยเปลี่ยนไตและไตเทียม": "Kidney Transplant and Hemodialysis Unit",
  "หน่วยเปลี่ยนไตและไตเทียม (ฟอกไต)": "Kidney Transplant and Hemodialysis Unit",
  "OR-เล็ก": "OR-เล็ก",
  "หน่วยไตเทียม": "Hemodialysis Unit",
  "หน่วยไตเทียมฉุกเฉิน": "Hemodialysis Unit",
  "ห้องตรวจพิเศษอายุรกรรม 2 (เบอร์ 22)": "Outpatient clinic No.22",
  "ห้องตรวจพิเศษอายุรกรรม 4 (เบอร์ 23)": "Outpatient clinic No.23",
  "หอผู้ป่วยปลูกถ่ายไขกระดูกและให้ยาเคมีบำบัดขนาดสูง": "Stem cell transplant unit",
  "หน่วยเคมีบำบัดผู้ป่วยนอก 2": "Oneday chemotherapy 2",
  "หอผู้ป่วย ศูนย์ศรีพัฒน์": "Sriphat Center",
  "ห้องรับบริจากmเลือด": "Bloodbank section",
  "ห้องฉายแสงอัลตราไวโอเลต": "Ultraviolet Irradiation Room",
  "ห้องเจาะเลือด รถเข็น": "Blood collection unit OPD 13",
  "หอผู้ป่วยสังเกตอาการ": "Observation ward",

  // Aliases
  "ห้องเบอร์ 19": "Room No.19",
  "ห้องตรวจ MRI": "MRI examination room",
  "ห้องเอกซเรย์คอมพิวเตอร์ เบอร์ 5": "CT scan room no.5",
  "ห้องเบอร์ 11": "Room No.11",
  "ห้องเบอร์ 13": "Room No.13",
  "ศูนย์บริหารจัดการสิ่งส่งตรวจ": "Specimen management center",
  "OPD เบอร์ 10": "OPD No.10",
  "OPD สังเกตอาการ": "OPD Observation",
  "พิเศษอายุรกรรม 5 (เบอร์ 24)": "Special Medicine 5 (Room 24)",
  "OPD เบอร์ 25": "OPD No.25",
  "EKG เบอร์ 12": "EKG No.12",
  "ห้องตรวจ 110": "Examination Room 110",
  "OPD ศัลยกรรม 2": "OPD Surgery 2",
  "หน่วยจัดหาและตรวจความปลอดภัย": "Blood acquisition and safety section",
  "CSSD": "CSSD",
  "OPD เบอร์ 3": "Outpatient clinic No.3",
  "OPD เบอร์ 4": "Outpatient clinic No.4",
  "OPD เบอร์ 5": "Outpatient clinic No.5",
  "Patho - Primary HPV Screenin": "Patho - Primary HPV Screening",
  "Patho - Liquid-based cytolog": "Patho - Liquid-based cytology",
  "OPD Retina": "OPD Retina",
  "เด็กป่วย (เบอร์ 28)": "Pediatric outpatient department",
  "OPD เบอร์ 29": "Outpatient clinic No.29",
  "ห้องจ่ายยาเด็กชั้น6*": "Cashier",
  "หู คอ จมูก (เบอร์ 6)": "ENT clinic (Room 6)",
  "ตา (เบอร์ 7)": "Eye Clinic (Room 7)",
  "หน่วยตรวจพิเศษทางระบบหัวใจและหลอดเลือดแบบภายนอก": "Non-invasive cardiovascular diagnostic unit",
  "ห้องตรวจศูนย์โรคสมอง": "Brain clinic",
  "Pain Clinic": "Pain Clinic",
  "OPD เบอร์ 26": "OPD No.26",
  "BMT": "BMT",
  "Sriphat Center": "Sriphat Center",

  // Building Names
  "อาคารเฉลิมพระบารมี": "Chalermprakiat Building",
  "อาคารตะวัน กังวานพงษ์": "Tawan Kangwanpong Building",
  "อาคารผู้ป่วย 7 (อาคารบุญสม มาร์ติน)": "Patient Building 7 (Boonsom Martin Building)",
  "อาคารบุญสม มาร์ติน": "Boonsom Martin",
  "อาคารสุจิณโณ": "Su Jinno Building",
  "อาคารศรีพัฒน์": "Sriphat Building",
  "ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์": "Sripat Faculty of Medicine",
  "อาคารศรีพัฒน์ คณะแพทยศาสตร์": "Sripat Faculty of Medicine",

  // General terms
  "ทางเชื่อม": "Bridge",
  "จุดเริ่มต้น": "Starting point",
  "ปลายทาง": "Destination",

  // Patient Building 7 (อาคารผู้ป่วย 7)
  "ห้องเปลี่ยนเสื้อผ้า เบอร์ 31": "Deressing room No.31",
  "หน่วยเวชศาสตร์นิวเคลียร์": "Devision of nuclear medicine",
  "ห้องตรวจเบอร์ 38": "Examination room no.38",
  "Electrocadiogram unit": "Electrocardiogram unit",
  "ลิฟต์": "Elevator",
  "ลิฟท์": "Elevator",
  "บันได": "Stairs",
  "บันไดหนีไฟ": "Fire exit stairs",
  "ประตูทางเข้าชั้น 1": "1st Floor Entrance",
  "ประตูทางเข้าหลังชั้น 1": "1st Floor Back Entrance",
  "โรงอาหาร": "Cafeteria",
};

/**
 * Automatically translates text to English if the current language is 'en'
 * and the user is not in the Admin panel.
 *
 * @param {string} text
 * @returns {string} translated text
 */
export function translateText(text) {
  if (!text || typeof text !== "string") return text || "";

  // Only translate if appLanguage is English and we are not in admin pages
  const currentLang = localStorage.getItem("appLanguage") || "th";
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  if (currentLang !== "en" || isAdmin) {
    return text;
  }

  const trimmed = text.trim();

  // Try exact match in map
  if (translationMap[trimmed]) {
    return translationMap[trimmed];
  }

  // Try floor regex match (e.g. "ชั้น 1" / "ชั้นที่ 1" -> "Floor 1")
  const floorMatch = trimmed.match(/^ชั้น(?:ที่)?\s*(\w+)$/);
  if (floorMatch) {
    return `Floor ${floorMatch[1]}`;
  }

  // Try elevator regex match (e.g. "ลิฟต์ 1" / "ลิฟท์ เบอร์ 2" -> "Elevator 1" / "Elevator 2")
  const elevatorMatch = trimmed.match(/^(ลิฟต์|ลิฟท์)\s*(เบอร์\s*)?([a-zA-Z0-9ก-ฮ]+)$/i);
  if (elevatorMatch) {
    return `Elevator ${elevatorMatch[3]}`;
  }

  // Try stairs regex match (e.g. "บันได A" / "บันไดหนีไฟ 1" -> "Stairs A" / "Fire exit stairs 1")
  const stairsMatch = trimmed.match(/^(บันได|บันไดหนีไฟ)\s*(เบอร์\s*)?([a-zA-Z0-9ก-ฮ]+)$/i);
  if (stairsMatch) {
    const type = stairsMatch[1] === "บันไดหนีไฟ" ? "Fire exit stairs" : "Stairs";
    return `${type} ${stairsMatch[3]}`;
  }

  // Try X-ray regex match (e.g. "ห้องเอกซเรย์ เบอร์ 43" -> "X-ray room no.43")
  const xrayMatch = trimmed.match(/^ห้องเอกซเรย์\s*เบอร์\s*(\d+)$/);
  if (xrayMatch) {
    return `X-ray room no.${xrayMatch[1]}`;
  }

  return text;
}

/**
 * Parses nameStr containing multiple names separated by delimiters.
 * Translates values to English if language is set to 'en' (and not admin).
 * Ensures both original and translated parts are in 'all' for searchability.
 *
 * @param {string} nameStr
 * @returns {object} { primary, aliases, all, display }
 */
export function parseNames(nameStr, forceThai = false) {
  if (!nameStr || typeof nameStr !== "string") {
    return {
      primary: nameStr || "",
      aliases: [],
      all: nameStr ? [nameStr] : [],
      display: nameStr || "",
    };
  }

  const originalParts = nameStr
    .split(/[,;|/]/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (originalParts.length === 0) {
    return {
      primary: "",
      aliases: [],
      all: [],
      display: "",
    };
  }

  const currentLang = forceThai ? "th" : (localStorage.getItem("appLanguage") || "th");
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  const isEn = currentLang === "en" && !isAdmin;

  const translatedParts = originalParts.map((part) => {
    if (translationMap[part]) return translationMap[part];

    // Check floor regex inside parts as well
    const floorMatch = part.match(/^ชั้น(?:ที่)?\s*(\w+)$/);
    if (floorMatch) return `Floor ${floorMatch[1]}`;

    // Elevator regex
    const elevatorMatch = part.match(/^(ลิฟต์|ลิฟท์)\s*(เบอร์\s*)?([a-zA-Z0-9ก-ฮ]+)$/i);
    if (elevatorMatch) return `Elevator ${elevatorMatch[3]}`;

    // Stairs regex
    const stairsMatch = part.match(/^(บันได|บันไดหนีไฟ)\s*(เบอร์\s*)?([a-zA-Z0-9ก-ฮ]+)$/i);
    if (stairsMatch) {
      const type = stairsMatch[1] === "บันไดหนีไฟ" ? "Fire exit stairs" : "Stairs";
      return `${type} ${stairsMatch[3]}`;
    }

    // X-ray regex
    const xrayMatch = part.match(/^ห้องเอกซเรย์\s*เบอร์\s*(\d+)$/);
    if (xrayMatch) return `X-ray room no.${xrayMatch[1]}`;

    return part;
  });

  const displayParts = isEn ? translatedParts : originalParts;
  const primary = displayParts[0];
  const aliases = displayParts.slice(1);

  // For search matching, collect all versions (both original Thai and translated English)
  const allSet = new Set();
  originalParts.forEach((p) => allSet.add(p));
  translatedParts.forEach((p) => allSet.add(p));
  const all = Array.from(allSet);

  return {
    primary,
    aliases,
    all,
    display: displayParts.join(", "),
  };
}

export default parseNames;